module.exports = __webpack_public_path__ + "img/1.4749954c.png";